import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams ,useNavigate} from "react-router-dom";

import { fetchMenu } from "../../actions/menuActions";
import "./css/HomeScreen.css";



import { useCart } from "../../components/CartContext";


// =========================================================
// HERO IMAGES
// STATIC - DO NOT CHANGE
// =========================================================

const heroImages = [
  "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=800&q=80",
];


// =========================================================
// FALLBACK MENU IMAGE
// =========================================================

const fallbackMenuImage =
  "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=300&q=80";


// =========================================================
// MENU ITEM
// =========================================================

function MenuItem({ item, onAddToCart }) {
  return (
    <div className="home-menu-item">

      <img
        src={item.image || fallbackMenuImage}
        alt={item.name}
        className="home-menu-item-image"
      />

      <div className="home-menu-item-details">

        <h3>
          {item.name}
        </h3>

        <p>
          {item.description}
        </p>

      </div>

      <div className="home-menu-item-action">

        <div className="home-menu-item-price">
          ₹{item.price}
        </div>

        <button
          type="button"
          className="add-cart-button"
          onClick={() => onAddToCart(item)}
        >
          + Add
        </button>

      </div>

    </div>
  );
}


// =========================================================
// MENU SECTION
// =========================================================

function MenuSection({
  id,
  title,
  subtitle,
  items,
  onAddToCart,
}) {
  return (
    <section
      id={id}
      className="home-menu-section"
    >

      <div className="home-section-title">

        <div className="section-decoration">
          <span></span>

          <span className="section-symbol">
            ✦
          </span>

          <span></span>
        </div>

        <h2>
          {title}
        </h2>

        <p>
          {subtitle}
        </p>

      </div>


      <div className="home-menu-grid">

        {items.map((item) => (

          <MenuItem
            key={item.id}
            item={item}
            onAddToCart={onAddToCart}
          />

        ))}

      </div>

    </section>
  );
}


// =========================================================
// CREATE SAFE SECTION ID
// =========================================================

function createSectionId(name) {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}


// =========================================================
// HOME SCREEN
// =========================================================

function HomeScreen() {

  const [cartOpen, setCartOpen] = useState(false);

  const navigate = useNavigate();
  // =======================================================
  // RESTAURANT ID FROM URL
  // =======================================================

  const { restaurantId ,tableId,} = useParams();


  // =======================================================
  // REDUX
  // =======================================================

  const dispatch = useDispatch();

  const {
    loading,
    categories,
    restaurantName,
    error,
  } = useSelector(
    (state) => state.menu
  );


  // =======================================================
  // CART
  // =======================================================

  const {
    cart,
    addToCart,
    increaseQuantity,
    decreaseQuantity,
    removeFromCart,
    cartCount,
    cartTotal,
  } = useCart();


  // =======================================================
  // FETCH MENU
  // =======================================================

  useEffect(() => {

    if (!restaurantId) {
      return;
    }

    dispatch(
      fetchMenu(restaurantId)
    );

  }, [dispatch, restaurantId]);


  // =======================================================
  // OPEN CART FROM HEADER
  // =======================================================

  useEffect(() => {

    const handleOpenCart = () => {
      setCartOpen(true);
    };


    window.addEventListener(
      "open-cart",
      handleOpenCart
    );


    return () => {

      window.removeEventListener(
        "open-cart",
        handleOpenCart
      );

    };

  }, []);


  // =======================================================
  // ADD ITEM TO CART
  //
  // IMPORTANT:
  // ADD BUTTON DOES NOT OPEN CART
  // =======================================================

  const handleAddToCart = (item) => {

    addToCart(item);

  };


  // =======================================================
  // MENU
  // =======================================================

  return (
    <main className="home-page">


      {/* =====================================================
          HERO
      ====================================================== */}

      <section
        id="home"
        className="home-hero"
      >

        <div className="home-hero-content">

          <div className="home-welcome">

            <span></span>

            <p>
              WELCOME TO TASTY BITE
            </p>

            <span></span>

          </div>


          <h1>
            Dive Into Delicious
            <br />

            <em>
              Meal Dishes
            </em>
          </h1>


          <div className="hero-decoration">
            ✦
          </div>


          <p className="hero-description">
            Fresh ingredients, authentic flavors
            and dishes prepared with love.
          </p>

        </div>


        {/* HERO FOOD GALLERY */}

        <div className="hero-food-gallery">

          {heroImages.map(
            (image, index) => (

              <div
                key={index}
                className={`hero-food-image hero-food-${index}`}
              >

                <img
                  src={image}
                  alt="Restaurant food"
                />

              </div>

            )
          )}

        </div>

      </section>


      {/* =====================================================
          MENU
      ====================================================== */}

      <div
        id="menu"
        className="menu-anchor"
      >
      </div>


      {/* =====================================================
          MENU LOADING
      ====================================================== */}

      {loading && (

        <div className="menu-loading">

          <p>
            Loading menu...
          </p>

        </div>

      )}


      {/* =====================================================
          MENU ERROR
      ====================================================== */}

      {!loading && error && (

        <div className="menu-error">

          <p>
            {error}
          </p>

        </div>

      )}


      {/* =====================================================
          DYNAMIC MENU
      ====================================================== */}

      {!loading &&
        !error &&
        categories.length > 0 && (

          <>
            {categories.map(
              (category) => (

                <MenuSection
                  key={category.id}

                  id={createSectionId(
                    category.name
                  )}

                  title={category.name}

                  subtitle={
                    category.description ||
                    `Enjoy our delicious ${category.name.toLowerCase()} selection`
                  }

                  items={
                    category.items || []
                  }

                  onAddToCart={
                    handleAddToCart
                  }
                />

              )
            )}
          </>

        )}


      {/* =====================================================
          EMPTY MENU
      ====================================================== */}

      {!loading &&
        !error &&
        categories.length === 0 && (

          <div className="menu-empty">

            <p>
              Menu is currently unavailable.
            </p>

          </div>

        )}


      {/* =====================================================
          OUR CULTURE
          STATIC
      ====================================================== */}

      <section
        id="about"
        className="home-culture"
      >

        <div className="culture-wrapper">

          <div className="culture-content">

            <p className="culture-small-title">
              OUR STORY
            </p>


            <h2>
              Our Culture
            </h2>


            <div className="culture-decoration">

              <span></span>

              <span>
                ✦
              </span>

              <span></span>

            </div>


            <p className="culture-description">
              We believe great food brings
              people together.
            </p>


            <p className="culture-description">
              Every dish is prepared using fresh
              ingredients, traditional techniques
              and a passion for good food.
            </p>


            <button
              type="button"
              className="culture-button"
            >
              Discover Our Story

              <span>
                →
              </span>

            </button>

          </div>


          {/* CULTURE IMAGES */}

          <div className="culture-images">

            <div className="culture-main-image">

              <img
                src="https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&w=1000&q=80"
                alt="Restaurant interior"
              />

            </div>


            <div className="culture-food-image">

              <img
                src="https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=700&q=80"
                alt="Restaurant food"
              />

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          GALLERY
          STATIC
      ====================================================== */}

      <section
        id="gallery"
        className="home-gallery-section"
      >

        <div className="home-section-title">

          <div className="section-decoration">

            <span></span>

            <span className="section-symbol">
              ✦
            </span>

            <span></span>

          </div>


          <h2>
            Our Gallery
          </h2>


          <p>
            A glimpse of our food, restaurant
            and dining experience.
          </p>

        </div>


        <div className="home-gallery-grid">

          <img
            src="https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&w=800&q=80"
            alt="Restaurant interior"
          />

          <img
            src="https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=800&q=80"
            alt="Restaurant food"
          />

          <img
            src="https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&w=800&q=80"
            alt="Pizza"
          />

          <img
            src="https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=800&q=80"
            alt="Restaurant dish"
          />

        </div>

      </section>


      {/* =====================================================
          FINAL CTA
      ====================================================== */}

      <section className="home-final-section">

        <p>
          READY TO TASTE?
        </p>


        <h2>
          Discover Our Menu
        </h2>


        <span>
          Explore our complete collection
          of freshly prepared dishes.
        </span>


        <br />


        <a
          href="#menu"
          className="home-final-button"
        >
          Explore Menu

          <b>
            →
          </b>

        </a>

      </section>


      {/* =====================================================
          FLOATING CART BUTTON
      ====================================================== */}

      {cartCount > 0 && (

        <button
          type="button"
          className="floating-cart-button"
          onClick={() => setCartOpen(true)}
        >

          <span className="cart-icon">
            🛒
          </span>

          <span>
            View Cart
          </span>

          <strong>
            {cartCount}
          </strong>

          <span>
            ₹{Number(cartTotal).toFixed(2)}
          </span>

        </button>

      )}


      {/* =====================================================
          CART OVERLAY
      ====================================================== */}

      {cartOpen && (

        <div
          className="cart-overlay"
          onClick={() =>
            setCartOpen(false)
          }
        >

          <div
            className="cart-drawer"
            onClick={(event) =>
              event.stopPropagation()
            }
          >

            {/* =============================================
                CART HEADER
            ============================================== */}

            <div className="cart-header">

              <div>

                <h2>
                  Your Order
                </h2>

                <p>

                  {cartCount} item

                  {cartCount !== 1
                    ? "s"
                    : ""}

                </p>

              </div>


              <button
                type="button"
                className="cart-close"
                onClick={() =>
                  setCartOpen(false)
                }
              >
                ×
              </button>

            </div>


            {/* =============================================
                CART CONTENT
            ============================================== */}

            {cart.length === 0 ? (

              <div className="empty-cart">

                <div className="empty-cart-icon">
                  🛒
                </div>

                <h3>
                  Your cart is empty
                </h3>

                <p>
                  Add some delicious dishes
                  to get started.
                </p>

              </div>

            ) : (

              <div className="cart-items">

                {cart.map((item) => (

                  <div
                    className="cart-item"
                    key={item.id}
                  >

                    {/* IMAGE */}

                    <img
                      src={
                        item.image ||
                        fallbackMenuImage
                      }
                      alt={item.name}
                    />


                    {/* ITEM INFO */}

                    <div className="cart-item-info">

                      <h3>
                        {item.name}
                      </h3>

                      <p>
                        ₹
                        {Number(item.price).toFixed(2)}
                      </p>


                      {/* QUANTITY */}

                      <div className="quantity-controls">

                        <button
                          type="button"
                          onClick={() =>
                            decreaseQuantity(
                              item.id
                            )
                          }
                        >
                          −
                        </button>


                        <span>
                          {item.quantity}
                        </span>


                        <button
                          type="button"
                          onClick={() =>
                            increaseQuantity(
                              item.id
                            )
                          }
                        >
                          +
                        </button>

                      </div>

                    </div>


                    {/* RIGHT SIDE */}

                    <div className="cart-item-right">

                      <strong>
                        ₹
                        {(
                          Number(item.price) *
                          item.quantity
                        ).toFixed(2)}
                      </strong>


                      <button
                        type="button"
                        className="remove-item"
                        onClick={() =>
                          removeFromCart(
                            item.id
                          )
                        }
                      >
                        Remove
                      </button>

                    </div>

                  </div>

                ))}

              </div>

            )}


            {/* =============================================
                CART FOOTER
            ============================================== */}

            {cart.length > 0 && (

              <div className="cart-footer">

                <div className="cart-total-row">

                  <span>
                    Total
                  </span>

                  <strong>
                    ₹
                    {Number(cartTotal).toFixed(2)}
                  </strong>

                </div>


                <button
                    type="button"
                    className="checkout-button"
                    onClick={() =>
                navigate(
                     `/${restaurantId}/table/${tableId}/checkout`
                    )
                    }
                    >
                        Continue to Order

                    <span>
                     →
                </span>
                </button>

              </div>

            )}

          </div>

        </div>

      )}

    </main>
  );
}

export default HomeScreen;